<div [hidden]="!menuEnabled">
  <div class="row mt-3 mb-3" [formGroup]="form">
    <div class="col-md-9 container my-auto border rounded">

      <div class="row mt-3">
        <div class="col-md-12 text-center">
          <h4 class="text-cust-blue" translate>Register</h4>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>CompanyName</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="dpa_companyname">
              <span class="text-danger"
                *ngIf="(formControl.dpa_companyname.touched || submitted) && formControl.dpa_companyname.value != null && formControl.dpa_companyname.value.trim().length == 0">
                <label translate>Please specify</label> <label translate>CompanyName</label>
                <!-- กรุณาระบุ ชื่อนิติบุคคล -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label translate>BusinessType</label>
            </div>
            <div class="col-md-6">
              <select class="form-control" formControlName="dpa_companytypeid"
                (change)="CompanyTypeChange($event.target.value)">
                <option value="" selected translate>Select</option>
                <option *ngFor="let c of companyTypeList" [value]="c.dpa_companytypeid">
                  {{c.dpa_name}}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="{{isRequiredRegisId ? 'required' : ''}}" translate>Regis ID no./Tax no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="dpa_registrationid">
              <span class="text-danger"
                *ngIf="(formControl.dpa_registrationid.touched || submitted) && isRequiredRegisId && formControl.dpa_registrationid.value != null && formControl.dpa_registrationid.value.trim().length == 0">
                <label translate>Please specify</label> <label translate>Regis ID no./Tax no.</label>
                <!-- กรุณาระบุ เลขประจำตัวผู้เสียภาษี/เลขนิติบุคคล -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Account no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" maxlength="13" formControlName="dpa_accountno">
              <span class="text-danger"
                *ngIf="(formControl.dpa_accountno.touched || submitted) && formControl.dpa_accountno.errors?.required">
                <label translate>Please specify</label> <label translate>Account no.</label>
                <!-- กรุณาระบุ เลขที่บัญชี -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>E-mail</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="emailaddress1">
              <span class="text-danger" *ngIf="(formControl.emailaddress1.touched || submitted) && (email == '')">
                <label translate>Please specify</label> <label translate>E-mail</label>
                <!-- กรุณาระบุช่อง Email หลัก -->
              </span>
              <span class="text-danger"
                *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
                <label translate>emailInvalid</label>
                <!-- อีเมลไม่ถูกต้อง -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Attorney-in-fact's name</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="firstname">
              <span class="text-danger"
                *ngIf="(formControl.firstname.touched || submitted) && formControl.firstname.errors?.required">
                <label translate>Please specify</label> <label translate>Attorney-in-fact's name</label>
                <!-- กรุณาระบุ ชื่อผู้รับมอบอำนาจ -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Attorney-in-fact's surname</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="lastname">
              <span class="text-danger"
                *ngIf="(formControl.lastname.touched || submitted) && formControl.lastname.errors?.required">
                <label translate>Please specify</label> <label translate>Attorney-in-fact's surname</label>
                <!-- กรุณาระบุ นามสกุลผู้รับมอบอำนาจ -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>ID no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control number" maxlength="13" formControlName="dpa_idcard">
              <span class="text-danger"
                *ngIf="submitted && (formControl.dpa_idcard.value == null || formControl.dpa_idcard.value.trim().length == 0)">
                <label translate>Please specify</label> <label translate>ID no.</label>
                <!-- กรุณาระบุ เลขบัตรประชาชน -->
              </span>
              <span class="text-danger"
                *ngIf="(formControl.dpa_idcard.value != null && formControl.dpa_idcard.value.trim().length > 0 && formControl.dpa_idcard.value.trim().length != 13) && !isForeign">
                <label translate>idNo13</label>
                <!-- กรุณาระบุ เลขบัตรประชาชนให้ครบ 13 หลัก -->
              </span>
              <!--<span class="text-danger"
                *ngIf="submitted && (formControl.dpa_idcard.value != null && formControl.dpa_idcard.value.trim().length > 0) && !isIdCardValid">
                <label translate>idNoInvalid</label>
              </span> -->
              <!-- กรุณาระบุ เลขบัตรประชาชนให้ถูกต้อง -->
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'c'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Regis Phone no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="telephone1" (keypress)="telephoneOnly($event)">
              <span class="text-danger"
                *ngIf="(formControl.telephone1.touched || submitted) && formControl.telephone1.errors?.required">
                <label translate>Please specify</label> <label translate>Regis Phone no.</label>
                <!-- กรุณาระบุช่องทางการติดต่อ -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Name</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="firstname">
              <span class="text-danger"
                *ngIf="(formControl.firstname.touched || submitted) && formControl.firstname.errors?.required">
                <label translate>Please specify</label> <label translate>Name</label>
                <!-- กรุณาระบุ ชื่อ -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Surname</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="lastname">
              <span class="text-danger"
                *ngIf="(formControl.lastname.touched || submitted) && formControl.lastname.errors?.required">
                <label translate>Please specify</label> <label translate>Surname</label>
                <!-- กรุณาระบุ นามสกุล -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'" style="display: none;">
            <div class="col-md-4 text-right">
              <label translate>Personal type</label>
            </div>
            <div class="col-md-6">
              <select class="form-control" formControlName="dpa_personaltypeid"
                (change)="personalTypeChange($event.target.value)">
                <option value="" translate>Select</option>
                <option *ngFor="let p of personalTypeList" [value]="p.dpa_personaltypeid">
                  {{p.dpa_name}}
                </option>
              </select>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label class="" translate>Date of Birth</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th" id="dob" (keypress)="numberdate($event)" maxlength="10"
                placeholder="{{'dobPlacHolder' | translate }}" formControlName="birthdate">
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label *ngIf="strictIdCard" translate>ID no.</label><label *ngIf="strictIdCard">/</label><br
                *ngIf="strictIdCard">
              <label *ngIf="!strictIdCard" class="required" translate>Passport no.</label>
              <label *ngIf="strictIdCard" class="required" translate>Regis Tax no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control number" maxlength="13" *ngIf="strictIdCard"
                formControlName="dpa_idcard">
              <input type="text" class="form-control" maxlength="13" *ngIf="!strictIdCard" formControlName="dpa_idcard"
                (keypress)="numberAndAlphabetOnly($event)">
              <span class="text-danger"
                *ngIf="submitted && (formControl.dpa_idcard.value == null || formControl.dpa_idcard.value.trim().length == 0) && strictIdCard">
                <label translate>Please specify</label> <label translate>ID no.</label>/<label translate>Regis Tax
                  no.</label>
                <!-- กรุณาระบุ เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี -->
              </span>
              <span class="text-danger"
                *ngIf="submitted && (formControl.dpa_idcard.value == null || formControl.dpa_idcard.value.trim().length == 0) && !strictIdCard">
                <label translate>Please specify</label> <label translate>Passport no.</label>
                <!-- กรุณาระบุ เลขพาสปอร์ต -->
              </span>
              <span class="text-danger"
                *ngIf="(formControl.dpa_idcard.value != null && formControl.dpa_idcard.value.trim().length > 0 && formControl.dpa_idcard.value.trim().length != 13) && strictIdCard">
                <label translate>idNoReGisNo13</label>
                <!-- กรุณาระบุ เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี ให้ครบ 13 หลัก -->
              </span>
               <!--<span class="text-danger"
                *ngIf="submitted && (formControl.dpa_idcard.value != null && formControl.dpa_idcard.value.trim().length > 0) && strictIdCard && !isIdCardValid">
                <label translate>idNoRegisNoInvalid</label>
              </span>-->
              <!-- กรุณาระบุ เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี ให้ถูกต้อง -->
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Account no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" maxlength="13" (keypress)="telephoneOnly($event)"
                formControlName="dpa_accountno">
              <span class="text-danger"
                *ngIf="(formControl.dpa_accountno.touched || submitted) && formControl.dpa_accountno.errors?.required">
                <label translate>Please specify</label> <label translate>Account no.</label>
                <!-- กรุณาระบุ เลขที่บัญชี -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label class="required" translate>RegisterE-mail</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" formControlName="emailaddress1">
              <span class="text-danger" *ngIf="(formControl.emailaddress1.touched || submitted) && (email == '')">
                <label translate>Please specify</label> <label translate>RegisterE-mail</label>
                <!-- กรุณาระบุช่อง Email หลัก -->
              </span>
              <span class="text-danger"
                *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
                <label translate>emailInvalid</label>
                <!-- Emailไม่ถูกต้อง -->
              </span>
            </div>
          </div>

          <div class="row mt-3" *ngIf="regisType == 'n'">
            <div class="col-md-4 text-right">
              <label class="required" translate>Regis Phone no.</label>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control" (keypress)="telephoneOnly($event)" formControlName="telephone1">
              <span class="text-danger"
                *ngIf="(formControl.telephone1.touched || submitted) && formControl.telephone1.errors?.required">
                <label translate>Please specify</label> <label translate>Regis Phone no.</label>
                <!-- กรุณาระบุ หมายเลขโทรศัพท์ -->
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <h5 class="text-cust-blue m-0" translate>Contact Address</h5>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="required" translate>Address</label>
        </div>
        <div class="col-9">
          <input type="text" class="form-control" formControlName="dpa_contact_homeno">
          <span class="text-danger"
            *ngIf="submitted && (formControl.dpa_contact_homeno.value == null || formControl.dpa_contact_homeno.value.trim().length == 0) && formControl.dpa_contact_homeno.errors?.required">
            <label translate>Please specify</label> <label translate>Address</label>
            <!-- กรุณาระบุ ที่อยู่ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-3 text-right">
          <label class="" translate>Moo</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" formControlName="dpa_contact_moo" maxlength="100">
        </div>
        <div class="col-3 text-right">
          <label class="" translate>Street</label>
        </div>
        <div class="col-3">
          <input type="text" class="form-control" formControlName="dpa_contact_street">
        </div>
      </div>

      <div class="row mt-3 select2-th">
        <div class="col-md-3 text-right">
          <label class="required" translate>Select Location</label>
        </div>
        <div class="col-md-9">
          <select class="form-control select2 select2th">
            <option value="" translate>Select</option>
            <option *ngFor="let sd of combinedAddressList" [value]="sd.id">
              {{sd.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3 select2-en">
        <div class="col-md-3 text-right">
          <label class="required" translate>Select Location</label>
        </div>
        <div class="col-md-9">
          <select class="form-control select2 select2en">
            <option value="" translate>Select</option>
            <option *ngFor="let sd of combinedAddressListEn" [value]="sd.id">
              {{sd.text_eng}}
            </option>
          </select>
          <span class="text-danger"
            *ngIf="submitted && (formControl.dpa_contact_subdistict.value == null || formControl.dpa_contact_subdistict.value.trim().length == 0) && formControl.dpa_contact_subdistict.errors?.required">
            <label translate>Please specify</label> <label translate>Address</label>
            <!-- กรุณาระบุ ที่อยู่ -->
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-3 text-right">
          <label class="required" translate>Sub-district</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_subdistictname" readonly>
        </div>
        <div class="col-md-3 text-right">
          <label class="required" translate>District</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_distictname" readonly>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-3 text-right">
          <label class="required" translate>Province</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_provincename" readonly>
        </div>
        <div class="col-md-3 text-right">
          <label class="required" translate>Postal code</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_postcodename" readonly>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-3 text-right">
          <label translate>Country</label>
        </div>
        <div class="col-md-3">
          <input type="text" class="form-control" formControlName="dpa_contact_countryname" readonly>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-3">
        </div>
        <div class="col-9">
          <div class="col-12 mt-3 mb-2 text-left ml-3" style="display: none;">
            <label translate>
              <input type="checkbox" (change)="newsAllowChange($event.target)">
              Would you like to receive notifications on the latest updates from the DPA?
            </label>
          </div>
          <div class="col-12 mt-2mb-2 text-left ml-3">
            <label translate>
              <input type="checkbox" (change)="consentAcceptChange($event.target)">
              Agree
              <!-- <button class="btn btn-link" (click)="showConsent()"></button> -->
            </label>
          </div>
        </div>
      </div>

      <div class="row mt-3 mb-3">
        <div class="col-md-12 text-center">
          <button class="btn btn-default mr-2" [disabled]="!isConsentAccept" (click)="preregister()"
            translate>Register</button>
          <button class="btn btn-default ml-2" (click)="clear()" translate>Regis Clear text</button>
        </div>
      </div>
    </div>
  </div>



  <!-- Modal Forward-->
  <div class="modal fade" id="consentModal" tabindex="-1" role="dialog" aria-labelledby="consentModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header text-white bg-cust-blue">
          <h5 class="modal-title" id="consentModalLabel">นโยบายความเป็นส่วนตัว (Privacy Policy)</h5>
        </div>
        <div class="modal-body">

          <div class="row border rounded">
            <div class="col-12 text-center">
              <h4 style="padding-top: 10px;">นโยบายความเป็นส่วนตัว (Privacy Policy)</h4>
            </div>
            <div class="row">
              <div class="col-12"  id="regPolicy">
               <!--  <p><span style="font-size:16px">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ.2551 ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ. ขอขอบคุณสำหรับความไว้วางใจจากท่าน และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล</span></p>
  
  <p><span style="font-size:16px">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy) เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล การเก็บรักษาข้อมูลไว้เป็นความลับ รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy Policy) ได้ (เป็น share link file)</span></p>
  
  <p>&nbsp;</p>
  
  <p><span style="font-size:16px">ขอแสดงความนับถือ</span></p>
  
  <p><span style="font-size:16px">สถาบันคุ้มครองเงินฝาก</span></p>-->
              </div>
          </div>
            <!--  <div class="col-12 mt-3">
              <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; สถาบันคุ้มครองเงินฝาก (สคฝ.) เป็นหน่วยงานของรัฐ
                จัดตั้งขึ้นตามพระราชบัญญัติสถาบันคุ้มครองเงินฝาก พ.ศ. 2551
                ยึดมั่นการดำเนินงานตามหลักบรรษัทภิบาลในการปฏิบัติงานอย่างเคร่งครัด สคฝ.
                ขอขอบคุณสำหรับความไว้วางใจจากท่าน
                และตระหนักดีว่าท่านต้องการความปลอดภัยในการทำธุรกรรม และการรักษาข้อมูลส่วนบุคคล</label>
              <br>
              <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; สคฝ. จึงได้กำหนดนโยบายความเป็นส่วนตัว (Privacy Policy)
                เพื่อให้ท่านมั่นใจเรื่องการคุ้มครองข้อมูลส่วนบุคคล การเก็บรักษาข้อมูลไว้เป็นความลับ
                รวมทั้งการเปิดเผยหรือการนำไปใช้ที่ต้องเป็นไปด้วยความรอบคอบ และคำนึงถึงความปลอดภัยของข้อมูลเป็นสำคัญ
                โดยท่านสามารถศึกษารายละเอียดของนโยบายความเป็นส่วนตัว (Privacy Policy)</label>
            </div>
            <div class="col-12 mt-3">
              <label>ขอแสดงความนับถือ</label>
            </div>
            <div class="col-12">
              <label>สถาบันคุ้มครองเงินฝาก</label>
            </div>
          </div>-->

          
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/register/register.component.html